/**
 * AlfaPureo React Native WebView bridge.
 * Keep in sync with src/shop/injectedBridge.ts in the app repo.
 */
(function () {
  if (window.__alfapureoAppBridgeTheme) {
    return;
  }
  window.__alfapureoAppBridgeTheme = true;

  var post = function (payload) {
    try {
      if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
        window.ReactNativeWebView.postMessage(JSON.stringify(payload));
      }
    } catch (e) {}
  };

  var isApp = !!(window.ReactNativeWebView) || /AlfaPureoApp/i.test(navigator.userAgent || '');
  if (!isApp) {
    return;
  }

  document.documentElement.classList.add('inside-mobile-app');
  if (document.body) {
    document.body.classList.add('inside-mobile-app');
  }
  window.__alfapureoUseCheckoutKit = true;

  window.AlfaPureoApp = window.AlfaPureoApp || {
    openSearch: function () {
      var cart = document.querySelector('#site-cart-sidebar') || document.querySelector('[data-js-site-cart-sidebar]');
      if (cart) {
        if (typeof cart.hide === 'function') { cart.hide(); }
        else { cart.removeAttribute('open'); cart.classList.remove('active'); }
      }
      var sidebar = document.querySelector('#site-search-sidebar');
      if (!sidebar) { return; }
      if (typeof sidebar.show === 'function') { sidebar.show(); return; }
      sidebar.setAttribute('open', '');
      sidebar.classList.add('active');
    },
    closeSearch: function () {
      var sidebar = document.querySelector('#site-search-sidebar');
      if (!sidebar) { return; }
      if (typeof sidebar.hide === 'function') { sidebar.hide(); return; }
      sidebar.removeAttribute('open');
      sidebar.classList.remove('active');
    },
    openCart: function () {
      var search = document.querySelector('#site-search-sidebar');
      if (search) {
        if (typeof search.hide === 'function') { search.hide(); }
        else { search.removeAttribute('open'); search.classList.remove('active'); }
      }
      var sidebar = document.querySelector('#site-cart-sidebar') || document.querySelector('[data-js-site-cart-sidebar]');
      if (!sidebar) { return; }
      if (typeof sidebar.show === 'function') { sidebar.show(); return; }
      sidebar.setAttribute('open', '');
      sidebar.classList.add('active');
    },
    closeCart: function () {
      var sidebar = document.querySelector('#site-cart-sidebar') || document.querySelector('[data-js-site-cart-sidebar]');
      if (!sidebar) { return; }
      if (typeof sidebar.hide === 'function') { sidebar.hide(); return; }
      sidebar.removeAttribute('open');
      sidebar.classList.remove('active');
    },
    clearCart: function () {
      fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
        .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          post({ type: 'CART_UPDATED', itemCount: cart.item_count || 0, cart: cart });
          if (typeof window.refreshCart === 'function') { window.refreshCart(); }
        })
        .catch(function () {
          post({ type: 'CART_UPDATED', itemCount: 0 });
        });
    },
    setCheckoutKit: function (enabled) {
      window.__alfapureoUseCheckoutKit = !!enabled;
    }
  };

  var sendCart = function (type) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        post({ type: type, itemCount: cart.item_count || 0, cart: cart });
      })
      .catch(function () {});
  };

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) { return; }
    var btn = e.target.closest('#CheckOut, button[name="checkout"]');
    if (!btn) { return; }
    sendCart('CHECKOUT');
    if (window.__alfapureoUseCheckoutKit) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  document.addEventListener('submit', function (e) {
    if (!e.target || e.target.id !== 'cart') { return; }
    sendCart('CHECKOUT');
    if (window.__alfapureoUseCheckoutKit) {
      e.preventDefault();
    }
  }, true);

  if (typeof window.refreshCart === 'function' && !window.refreshCart.__alfapureoWrapped) {
    var orig = window.refreshCart;
    var wrapped = function () {
      var result = orig.apply(this, arguments);
      setTimeout(function () { sendCart('CART_UPDATED'); }, 300);
      return result;
    };
    wrapped.__alfapureoWrapped = true;
    window.refreshCart = wrapped;
  }

  document.addEventListener('add-to-cart', function () {
    setTimeout(function () { sendCart('CART_UPDATED'); }, 300);
  });

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) { return; }
    var a = e.target.closest('a[data-share], a.share, a[href*="facebook.com/sharer"], a[href*="twitter.com/intent"], a[href*="pinterest.com/pin"], a[href*="wa.me"], a[href*="api.whatsapp.com"]');
    if (!a) { return; }
    e.preventDefault();
    post({ type: 'SHARE', url: a.href || window.location.href, title: document.title });
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) { return; }
    var login = e.target.closest('a[href*="/account"], a[href*="/customer_authentication"], a[href*="account.alfapureo"], a.area--account');
    if (!login) { return; }
    e.preventDefault();
    e.stopPropagation();
  }, true);

  sendCart('CART_UPDATED');
  post({
    type: 'CUSTOMER_STATE',
    loggedIn: !!(document.body && document.body.classList.contains('customer-logged-in')),
    email: window.__alfapureoCustomerEmail || null
  });
})();
